import { httpClient } from './../httpClient';
import { apiErrorHandler } from './helpers';

export const createCalendarBookmark = payload =>
  httpClient
    .post('/calendarBookmark', payload)
    .then(response => response.data)
    .catch(apiErrorHandler);

export const getCalendarBookmark = ({ property }) =>
  httpClient
    .get('/calendarBookmark', { params: { property } })
    .then(response => response.data)
    .catch(apiErrorHandler);

export const patchPinCalendarBookmark = id =>
  httpClient
    .patch(`/calendarBookmark/pin/${id}`)
    .then(response => response.data)
    .catch(apiErrorHandler);

export const deleteCalendarBookmark = id =>
  httpClient
    .delete(`/calendarBookmark/${id}`)
    .then(response => response.data)
    .catch(apiErrorHandler);
